import * as z from 'zod';
import { createSelectSchema } from 'drizzle-zod';
import type { QueryResult } from '@iichi/schema-database/types/member-picture';
import * as schema from '@iichi/schema-database';
import { mimeTypeToExtension, mimeTypeSchema, type MimeType } from '../lib/picture';

export const memberPictureSchema = createSelectSchema(schema.memberPicture)
  .pick({
    memberId: true,
    createdAt: true,
    updatedAt: true,
  })
  .extend({
    // 型の調整
    contentType: mimeTypeSchema,
    imagePath: z.string().regex(/^\/avatar\/\d+\/av-[a-zA-Z0-9]{13}-640\.(jpg|gif|png)$/),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
  });

export type MemberPicture = z.infer<typeof memberPictureSchema>;

export const transformMemberPicture = (data: QueryResult): MemberPicture => {
  const memberPicture = {
    ...data,
    imagePath: `/avatar/${data.memberId}/av-${String(data.slug).padStart(13, '0')}-640.${mimeTypeToExtension(data.contentType as MimeType)}`,
  };

  return memberPictureSchema.parse(memberPicture);
};
